import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import { HP_VIEWPORT_ALIGNMENT } from "../../../../constants/Constants";
import "../../styles/styles.css";

const LockedSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#0085FF"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

/**
 * The way out of an alignment lock.
 *
 * A locked viewport refuses to be panned sideways and re-pins itself around every
 * series loaded into it, so without something on the viewport itself a radiologist
 * who wanted to move that image across would have no idea why it kept snapping
 * back, let alone how to stop it. Hence a padlock over the image: it appears only
 * while the lock is on, names the side it is holding, and clicking it lets go.
 *
 * Re-locking deliberately is not here — that lives in the Rotation menu with the
 * rest of the alignment actions, so this stays one unambiguous affordance rather
 * than a toggle a stray click could turn back on.
 */
const ViewportAlignmentLockIndicator = ({ viewportIndex }) => {
  const { t } = useTranslation();
  const { alignmentLocks, unlockViewportAlignment } = useContext(ViewportContext);

  const alignment = alignmentLocks?.get(viewportIndex);
  if (!alignment) return null;

  const title =
    alignment === HP_VIEWPORT_ALIGNMENT.LEFT
      ? t("viewer.tools.unlock-left", "Locked to the left — click to unlock")
      : t("viewer.tools.unlock-right", "Locked to the right — click to unlock");

  const handleUnlock = (e) => {
    e.stopPropagation();
    unlockViewportAlignment(viewportIndex);
  };

  return (
    <div
      className="viewport-sync-link-wrapper"
      style={{ marginTop: "4px", marginRight: "0px", pointerEvents: "auto" }}
    >
      <span className="viewport-nav-icon" title={title} onClick={handleUnlock}>
        <LockedSVG />
      </span>
    </div>
  );
};

export default ViewportAlignmentLockIndicator;
